module.exports = __webpack_public_path__ + "img/shifu.0904f64.png";